import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import BaseFooter from '@layout/Footer/BaseFooter';
import Header from './Header';
import AppContainer from '../Components/AppContainer';
import LayoutContainer from '../Components/Container';

const Container = styled(LayoutContainer)`
  min-width: 0px;
  ${mediaQuery.uptoMobile} {
    width: 100vw;
  }
`;

const CareerAppContainer = styled(AppContainer)`
  width: 1366px;
  grid-row-gap: ${Spacings.SPACING_0B};
  ${mediaQuery.uptoTablet} {
    width: 100%;
  }
`;

const StyedBaseFooter = styled(BaseFooter)`
  margin-top: ${Spacings.SPACING_0B};
`;

const CareersPageLayout = ({ children, className }) => {
  return (
    <Container className={className}>
      <Header />
      <CareerAppContainer className="container">{children}</CareerAppContainer>
      <StyedBaseFooter display noFooter={false} />
    </Container>
  );
};
export default CareersPageLayout;
